module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, [_vm._v("\n\t\t\t\t\t由于便民服务桥功能升级，便民服务桥公安服务板块公安业务的预约和办理请前往“湖南公安服务平台长沙专区”、“我的长沙小程序”或“我的长沙APP”办理,“货车通行证”业务请前往长沙交警公众号办理,无犯罪记录证明业务请前往长沙公安公众号进行办理。\n\t\t\t\t")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38856eb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice_dialog/notice_dialog.vue
// module id = 315
// module chunks = 40